export const PLAN_ORDER_RESETSTATE = 'PLAN_ORDER_RESETSTATE';

export const GET_ADMIN_PLAN_ORDER_SUCCESS = 'GET_ADMIN_PLAN_ORDER_SUCCESS';
export const GET_ADMIN_PLAN_COMPARE_DATA_SUCCESS = 'GET_ADMIN_PLAN_COMPARE_DATA_SUCCESS';
export const GET_PLAN_ORDER_SUCCESS = 'GET_PLAN_ORDER_SUCCESS';
export const UPDATE_PLAN_ORDER_STOREY_SORT_SUCCESS = 'UPDATE_PLAN_ORDER_STOREY_SORT_SUCCESS';
export const ADD_STOREY_SUCCESS = 'ADD_STOREY_SUCCESS';
export const DELETE_STOREY_SUCCESS = 'DELETE_STOREY_SUCCESS';
export const SEND_PLAN_ORDER_SUCCESS = 'SEND_PLAN_ORDER_SUCCESS';
export const SAVE_PLAN_ORDER_SUCCESS = 'SAVE_PLAN_ORDER_SUCCESS';
export const UPDATE_PLAN_ORDER_SUCCESS = 'UPDATE_PLAN_ORDER_SUCCESS';
export const EDIT_EXTERNAL_FILE_ANNOTATION_SUCCESS = 'EDIT_EXTERNAL_FILE_ANNOTATION_SUCCESS';
export const ADMIN_SEND_PLAN_ORDER_SUCCESS = 'ADMIN_SEND_PLAN_ORDER_SUCCESS';
export const EDIT_PLAN_ANNOTATION_SUCCESS = 'EDIT_PLAN_ANNOTATION_SUCCESS';
export const SAVE_PLAN_ANNOTATION_SUCCESS = 'SAVE_PLAN_ANNOTATION_SUCCESS';
export const UPDATE_PLAN_FIRM_SUCCESS = 'UPDATE_PLAN_FIRM_SUCCESS';
export const UPDATE_PLAN_EDITOR_SUCCESS = 'UPDATE_PLAN_EDITOR_SUCCESS';
export const REMOVE_PLAN_ORDER_ROW_SUCCESS = 'REMOVE_PLAN_ORDER_ROW_SUCCESS';
export const ADD_ORDER_ROW_SUCCESS = 'ADD_ORDER_ROW_SUCCESS';
export const RETURN_TO_BROKER = 'RETURN_TO_BROKER';
export const SEND_TO_PLAN_FIRM_SUCCESS = 'SEND_TO_PLAN_FIRM_SUCCESS';
export const DELIVER_PLAN_ORDER_SUCCESS = 'DELIVER_PLAN_ORDER_SUCCESS';
export const ADMIN_RETURN_PLAN_ORDER_SUCCESS = 'ADMIN_RETURN_PLAN_ORDER_SUCCESS';
export const RETURN_SKETCHUP_PLAN_ORDER_SUCCESS = 'RETURN_SKETCHUP_PLAN_ORDER_SUCCESS';
export const RETURN_ROOMSKETCHER_PLAN_ORDER_SUCCESS = 'RETURN_ROOMSKETCHER_PLAN_ORDER_SUCCESS';
export const DOWNLOAD_FILES_PLAN_ORDER_SUCCESS = 'DOWNLOAD_FILES_PLAN_ORDER_SUCCESS';
export const EMAIL_FILES_PLAN_ORDER_SUCCESS = 'EMAIL_FILES_PLAN_ORDER_SUCCESS';
export const UPDATE_PLACEMENTS_SUCCESS = 'UPDATE_PLACEMENTS_SUCCESS';
export const APPROVE_PLAN_ORDER_ADMIN_SUCCESS = 'APPROVE_PLAN_ORDER_ADMIN_SUCCESS';
export const GENERATE_FILES_PLAN_ORDER_ADMIN_SUCCESS = 'GENERATE_FILES_PLAN_ORDER_ADMIN_SUCCESS';

export const ADMIN_ADD_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS =
    'ADMIN_ADD_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS';
export const ADMIN_ADD_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS =
    'ADMIN_ADD_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS';
export const ADMIN_DELETE_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS =
    'ADMIN_DELETE_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS';
export const ADMIN_DELETE_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS =
    'ADMIN_DELETE_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS';
export const ADMIN_ADD_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS =
    'ADMIN_ADD_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS';
export const ADMIN_DELETE_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS =
    'ADMIN_DELETE_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS';
export const ADMIN_UPDATE_START_DATE_SUCCESS = 'ADMIN_UPDATE_START_DATE_SUCCESS';

export const ADD_PLAN_ORDER_STOREY_BLUEPRINT_FILE_SUCCESS =
    'ADD_PLAN_ORDER_STOREY_BLUEPRINT_FILE_SUCCESS';
export const ADD_PLAN_ORDER_STOREY_SKETCHUP_2D_FILE_SUCCESS =
    'ADD_PLAN_ORDER_STOREY_SKETCHUP_2D_FILE_SUCCESS';
export const ADD_PLAN_ORDER_STOREY_SKETCHUP_3D_FILE_SUCCESS =
    'ADD_PLAN_ORDER_STOREY_SKETCHUP_3D_FILE_SUCCESS';
export const ADD_PLAN_ORDER_STOREY_ROOMSKETCHER_2D_FILE_SUCCESS =
    'ADD_PLAN_ORDER_STOREY_ROOMSKETCHER_2D_FILE_SUCCESS';
export const ADD_PLAN_ORDER_STOREY_ROOMSKETCHER_3D_FILE_SUCCESS =
    'ADD_PLAN_ORDER_STOREY_ROOMSKETCHER_3D_FILE_SUCCESS';

export const PLAN_ORDER_TOGGLE_TEMPLATE_GENERATION_SUCCESS =
    'PLAN_ORDER_TOGGLE_TEMPLATE_GENERATION_SUCCESS';
export const PLAN_ORDER_ADMIN_GRAB_SUCCESS = 'PLAN_ORDER_ADMIN_GRAB_SUCCESS';

export const ADMIN_DELETE_DELIVERY_FILE_SUCCESS = 'ADMIN_DELETE_DELIVERY_FILE_SUCCESS';
export const HIDE_DELIVERY_FAILURE = 'HIDE_DELIVERY_FAILURE';

export const SKETCHUP_STATUS_SET_SUCCESSFULLY = 'SKETCHUP_STATUS_SET_SUCCESSFULLY';
export const ROOMSKETCHER_STATUS_SET_SUCCESSFULLY = 'ROOMSKETCHER_STATUS_SET_SUCCESSFULLY';
export const INACTIVATE_EXTERNAL_FILE_SUCCESS = 'INACTIVATE_EXTERNAL_FILE_SUCCESS';

export const ADMIN_RESET_SCHEDULED_PLAN_ORDER_DELIVERY_SUCCESS =
    'ADMIN_RESET_SCHEDULED_PLAN_ORDER_DELIVERY_SUCCESS';

export const SET_PLAN_ORDER_SUCCESS = 'SET_PLAN_ORDER_SUCCESS';
export const RESET_PLAN_ORDER_ARCHIVE_STATE_SUCCESS = 'RESET_PLAN_ORDER_ARCHIVE_STATE_SUCCESS';

export const RETURN_CUBI_CASA_ORDER_SUCCESS = 'RETURN_CUBI_CASA_ORDER_SUCCESS';
export const MANUAL_SYNC_CUBI_CASA_ORDER_SUCCESS = 'MANUAL_SYNC_CUBI_CASA_ORDER_SUCCESS';
export const CONNECT_CUBI_CASA_ORDER_SUCCESS = 'CONNECT_CUBI_CASA_ORDER_SUCCESS';

export const DELETE_CUBI_CASA_ORDER_SUCCESS = 'DELETE_CUBI_CASA_ORDER_SUCCESS';
